module.exports = __webpack_public_path__ + "static/img/10.8b14eba3.jpg";